<ng-container *transloco="let t;">
  <div class="loader-while" *ngIf="!detailsParsed">
    <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
  </div>
  <div class="asset-details-section" *ngIf="detailsParsed">
    <div class="asset-details-card-containers-header">
      <div class="asset-details-card-containers">
        <div class="other-card">
          <!--<div class="item-balance">{{pi.balance}}</div>-->
          <div class="other-card-img" [ngClass]="{'full-image':pi.metadata.properties.category=='armor'}">
            <div class="item-balance">{{pi.balance}}</div>
            <img src="{{pi.metadata.image}}" />
          </div>
          <div class="other-card-content">
            <div class="name-row">
              <!-- <span>{{pi.metadata.nameFormatted}}</span> -->
              <span>{{t(pi.metadata.name+'.name'|replace:'powerup-':'' )}}</span>
              <span>{{t('shared.type')}}: {{pi.metadata.typeFormatted}}</span>
              <!--<span>Description: {{pi.metadata.descriptionFormatted}}</span>-->
              <!--<span *ngIf="pi.data.order" class="price-span">${{pi.data.order.priceUSD.toLocaleString()}}</span>-->
            </div>
            <div class="nft-crafting-progress" *ngIf="pi.craftingPercentage">
              <div class="nft-crafting-level-icon" *ngFor="let cr of craftingLevels">
                <img src="./assets/img/nftItems/tiers/level-{{cr.level}}.png"
                  [ngClass]="{'unselected': cr.level!=pi.craftingStage}" />
              </div>
              <!--<span>[{{pi.craftingStage}}/{{pi.craftingMax}}]</span>
          <div class="progress-bar">
                <span class="progress-bar-fill" style="width: {{pi.craftingPercentage}}%;"></span>
              </div>-->
            </div>
            <div class="nft-icon" *ngIf="pi.kind=='nft'">
              <img src="./assets/img/Icon/nft-icon.svg" *ngIf='!pi.metadata.properties.bound' />
              <img src="./assets/img/Icon/nft-bound.png" *ngIf='pi.metadata.properties.bound' />
            </div>
          </div>
        </div>
      </div>
      <div class="asset-details-infos-containers">
        <div class="asset-details-header" *ngIf="pi.kind=='nft'">
          <div class="asset-details-listing-sale">
            <div class="item-block" *ngIf="pi.order">
              <img src="./assets/img/Icon/kmon-logo-micro.png">
              <span>{{pi.order.priceFormatted.toLocaleString()}}</span>
            </div>
          </div>
          <div class="asset-details-buttons">
            <div class="button-outline"
              *ngIf="pi.craftingStage<=5 && pi.craftingStage!==undefined || pi.metadata.properties.bound"
              (click)="openCraft(pi)">
              {{t('shared.craft')}}
            </div>
            <div class="button-gradient" *ngIf="!pi.metadata.properties.bound && !pi.order &&  !isLoading && !isSuccess"
              (click)="showSaleModal=true">
              {{t('shared.sell')}}
            </div>
            <div class="button-gradient" *ngIf="!pi.metadata.properties.bound && pi.order && !isLoading && !isSuccess"
              (click)="cancelListing()">
              {{t('assets.removeFromSale')}}
            </div>
            <div class="button-gradient" *ngIf="!isLoading && isSuccess">
              <fa-icon [icon]="['fas', 'check']"></fa-icon>
            </div>
            <div class="button-gradient" *ngIf="isLoading && !isSuccess">
              <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
            </div>
            <div class="button-grey" *ngIf="!pi.metadata.properties.bound" (click)="showTransferModal=true">
              {{t('shared.transfer')}}
            </div>
          </div>
        </div>
        <div class="asset-details-details">
          <!-- <h1>{{pi.metadata.nameFormatted}}</h1> -->
          <!-- <p>{{pi.metadata.descriptionFormatted}}</p> -->
          <span>{{t(pi.metadata.name+'.name'|replace:'powerup-':'' )}}</span>
          <p>{{t(pi.metadata.name+'.description'|replace:'powerup-':'' )}}</p>
        </div>
        <div class="asset-details-inside-content">
        </div>
      </div>
    </div>
    <div class="asset-details-other-items" *ngIf="pi.kind=='nft'">
      <h3>{{t('assets.yourOtherItems')}}</h3>
      <div class="asset-details-other-items-container">
        <div class="other-card" *ngFor="let ot of otherItems | itemsFilterType: filterItemCategory">
          <div class="other-card-img" [ngClass]="{'full-image':ot.metadata.properties.category=='armor'}">
            <img src="{{ot.metadata.image}}">
            <div class="cr cr-top cr-right cr-purple" *ngIf="ot.order">{{t('shared.onSale')}}</div>
          </div>
          <div class="other-card-content">
            <div class="name-row">
              <!-- <span>{{ot.metadata.nameFormatted}}</span> -->
              <span>{{t(ot.metadata.name+'.name'|replace:'powerup-':'' )}}</span>
              <span>{{t('shared.type')}}: {{ot.metadata.typeFormatted}}</span>
            </div>
            <div class="button-outline button-outline-xs" (click)="openDetails(ot)">
              {{t('shared.details')}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="asset-details-other-items">
      <h3>{{t('assets.fromPrimusBazaar')}}</h3>
      <div class="asset-details-other-items-container">
        <div class="other-card" *ngFor="let ot of ingameItems">
          <div class="other-card-img">
            <img src="{{ot.img}}">
          </div>
          <div class="other-card-content">
            <div class="name-row">
              <span>{{ot.titleFormatted}}</span>
              <span>{{t('shared.type')}}: {{ot.typeFormatted}}</span>
            </div>
            <div class="button-outline button-outline-xs" (click)="openPrimusBazaar(ot)">
              {{t('shared.buy')}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="asset-details-other-items">
      <div class="title-filter">
        <h3>{{t('assets.fromAuctionHouse')}}</h3>
        <div class="right-actions">
          <div class="action-life" (click)="filterAuction=''">
            <!--<fa-icon [icon]="['fas', 'times']"></fa-icon>-->
            <span>{{t('shared.showAll')}}</span>
          </div>
          <div class="action-life" (click)="filterAuction='hunting boost'">
            <img src="./assets/img/nftItems/Tag-Gold.png" />
            <span>{{t('shared.badges')}}</span>
          </div>
          <div class="action-life" (click)="filterAuction='equipment'">
            <img src="./assets/img/nftItems/Vanquisher-Helmet-Bronze.png" />
            <span>{{t('shared.equipment')}}</span>
          </div>
          <div class="action-life" (click)="filterAuction='caring boost'">
            <img src="./assets/img/nftItems/Training-1.png" />
            <span>{{t('shared.powerups')}}</span>
          </div>
          <!--<div class="action-life" (click)="filterAuction='sold'">
        <img src="./assets/img/Icon/sold-small.png" />
        <span>Sold</span>
      </div>-->
        </div>
      </div>
      <div class="asset-details-other-items-container">
        <div class="other-card" *ngFor="let ot of otherItemsBuy | itemsFilterType: filterAuction">
          <div class="other-card-img" [ngClass]="{'full-image':ot.metadata.properties.category=='armor'}">
            <img src="{{ot.metadata.image}}">
          </div>
          <div class="other-card-content">
            <div class="name-row">
              <!-- <span>{{ot.metadata.nameFormatted}}</span> -->
              <span>{{t(ot.metadata.name+'.name'|replace:'powerup-':'' )}}</span>
              <span>{{t('shared.type')}}: {{ot.metadata.typeFormatted}}</span>
            </div>
            <div class="button-outline button-outline-xs" (click)="openAuctionHouse(ot)">
              {{t('shared.buy')}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="transfer-modal-overlay" *ngIf="showTransferModal">
      <div class="transfer-modal">
        <div class="transfer-modal-transfer" *ngIf="!isSuccess">
          <div class="transfer-modal-text">
            <h3>{{t('shared.transfer')}}</h3>
            <!-- <p class="text-gray">{{t('assets.yousendthis')}} {{pi.metadata.nameFormatted}} -->
              <p class="text-gray">{{t('assets.yousendthis')}} {{t(pi.metadata.name+'.name'|replace:'powerup-':'' )}}
              {{t('assets.toAnotherWallet')}} </p>
            <p class="text-gray">{{t('assets.enterReceiverAddress')}}.</p>
          </div>
          <div class="transfer-modal-input">
            <p>{{t('shared.walletAddress')}}</p>
            <input type="number" placeholder="1" [(ngModel)]="amountTransfer" *ngIf="pi.balance>1"/>
            <input type="text" placeholder="0x00000..." [(ngModel)]="receiverAddress"
              (ngModelChange)="isValidAddressKmon()" />
          </div>
          <div class="transfer-modal-buttons">
            <div class="button-outline" (click)="showTransferModal=false" *ngIf="!isLoading">
              {{t('shared.cancel')}}
            </div>
            <div class="button-gradient" *ngIf="validAddress && !isLoading && amountTransfer>=1 && amountTransfer<=pi.balance" (click)="checkAllowanceItems()">
              {{t('shared.proceed')}}
            </div>
            <div class="button-gradient disabled" *ngIf="!validAddress || amountTransfer<1 || amountTransfer>pi.balance">
              {{t('shared.proceed')}}
            </div>
            <div class="button-gradient" *ngIf="isLoading">
              <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
            </div>
          </div>
        </div>
        <div class="transfer-modal-success" *ngIf="isSuccess">
          <div class="transfer-modal-text">
            <h3>{{t('shared.success')}}</h3>
            <p>{{t('shared.theKryptomon')}} {{t(pi.metadata.name+'.name'|replace:'powerup-':'' )}} {{t('assets.hasBeenTransfered')}}.</p>
            <!-- <p>{{t('shared.theKryptomon')}} {{pi.metadata.nameFormatted}} {{t('assets.hasBeenTransfered')}}.</p> -->
          </div>
          <div class="transfer-modal-buttons">
            <div class="button-outline" (click)="closeTransferProcedure()">
              {{t('shared.close')}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sale-modal-overlay" *ngIf="showSaleModal">
      <div class="sale-modal">
        <div class="sale-listing-init" *ngIf="!showConfirmationListing && !isSuccess">
          <div class="other-card">
            <div class="popup-sale-left">
              <div class="popup-card">
                <!--<div class="item-balance">{{pi.balance}}</div>-->
                <div class="other-card-img" [ngClass]="{'full-image':pi.metadata.properties.category=='armor'}">
                  <div class="item-balance">{{pi.balance}}</div>
                  <img src="{{pi.metadata.image}}" />
                </div>
                <div class="other-card-content">
                  <div class="name-row">
                    <!-- <span>{{pi.metadata.nameFormatted}}</span> -->
                    <span>{{t(pi.metadata.name+'.name'|replace:'powerup-':'' )}}</span>
                    <span>{{t('shared.type')}}: {{pi.metadata.typeFormatted}}</span>
                    <!--<span>Description: {{pi.metadata.descriptionFormatted}}</span>-->
                    <!--<span *ngIf="pi.data.order" class="price-span">${{pi.data.order.priceUSD.toLocaleString()}}</span>-->
                  </div>
                  <div class="nft-crafting-progress" *ngIf="pi.craftingPercentage">
                    <div class="nft-crafting-level-icon" *ngFor="let cr of craftingLevels">
                      <img src="./assets/img/nftItems/tiers/level-{{cr.level}}.png"
                        [ngClass]="{'unselected': cr.level!=pi.craftingStage}" />
                    </div>
                    <!--<span>[{{pi.craftingStage}}/{{pi.craftingMax}}]</span>
              <div class="progress-bar">
                    <span class="progress-bar-fill" style="width: {{pi.craftingPercentage}}%;"></span>
                  </div>-->
                  </div>
                  <div class="nft-icon" *ngIf="pi.kind=='nft'">
                    <img src="./assets/img/Icon/nft-icon.svg" *ngIf='!pi.metadata.properties.bound' />
                    <img src="./assets/img/Icon/nft-bound.png" *ngIf='pi.metadata.properties.bound' />
                  </div>
                </div>
              </div>
            </div>
            <div class="popup-sale-right">
              <div class="sale-details-input">
                <div class="sale-input-titles">
                  <h3>{{t('assets.listSale')}}</h3>
                  <p class="text-gray">{{t('assets.setPriceExpDate')}} {{t(pi.metadata.name+'.name'|replace:'powerup-':'' )}}</p>
                  <!-- <p class="text-gray">{{t('assets.setPriceExpDate')}} {{pi.metadata.nameFormatted}}</p> -->
                  <div class="prices">
                    <span *ngIf="listingPrice>0"><img
                        src="./assets/img/Icon/kmon-logo-micro.png">{{listingPrice.toLocaleString()}}</span>
                    <span *ngIf="listingPrice==undefined || listingPrice=='' || listingPrice == 0"><img
                        src="./assets/img/Icon/kmon-logo-micro.png">0</span>
                    <span>{{usdPrice.toLocaleString()}}$</span>
                  </div>
                </div>
                <div class="sale-input-fields">
                    <div class="sale-input-field">
                    <p>{{t('shared.quantity')}}</p>
                    <div class="input-price">
                      <input type="number" [(ngModel)]="itemAmount" placeholder="1">
                    </div>
                  </div>
                  <div class="sale-input-field">
                    <p>{{t('shared.price')}}</p>
                    <div class="input-price">
                      <span><img src="./assets/img/Icon/kmon-logo-micro.png"></span>
                      <input type="number" [(ngModel)]="listingPrice" placeholder="2,000"
                        (ngModelChange)="updateKMONPrice()">
                    </div>
                  </div>
                  <div class="sale-input-field">
                    <p>{{t('shared.expirationDate')}}</p>
                    <input type="date" [ngModel]="expirationDate | date:'dd/mm/yy'" placeholder="dd/mm/yyyy"
                      (ngModelChange)="checkDateValidity($event)">
                  </div>
                </div>
                <div class="sale-modal-buttons">
                  <div class="button-outline" (click)="showSaleModal=false" *ngIf="!isLoading">
                    {{t('shared.cancel')}}
                  </div>
                  <div class="button-gradient" (click)="showConfirmationListing=true"
                    *ngIf="listingPrice>0 && expirationDateUnix>0 && itemAmount>0 && itemAmount<= pi.balance">
                    {{t('assets.listSale')}}
                  </div>
                  <div class="button-gradient disabled"
                    *ngIf="listingPrice==undefined || listingPrice=='' || expirationDateUnix==0 || listingPrice<=0 || itemAmount> pi.balance || itemAmount==0">
                    {{t('assets.listSale')}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="sale-listing-confirm" *ngIf="showConfirmationListing && !isSuccess">
          <div class="sale-modal-text">
            <h3>{{t('shared.pleaseConfirm')}}</h3>
            <p> {{t('assets.yourlist',{name:t(pi.metadata.name+'.name'|replace:'powerup-':'' ),price:listingPrice.toLocaleString()})}}</p>
            <!-- <p> {{t('assets.yourlist',{name:pi.metadata.nameFormatted,price:listingPrice.toLocaleString()})}}</p> -->
            <p>{{t('assets.reenterPrice')}}.</p>
          </div>
          <div class="sale-modal-input">
            <p>{{t('shared.price')}}</p>
            <div class="input-price">
              <img src="./assets/img/Icon/kmon-logo-micro.png">
              <input type="number" [(ngModel)]="confirmPrice" placeholder="2,000" min="0">
            </div>
          </div>
          <div class="sale-modal-buttons">
            <div class="button-outline" (click)="showConfirmationListing=false" *ngIf="!isLoading">
              {{t('shared.cancel')}}
            </div>
            <div class="button-gradient" *ngIf="(confirmPrice==listingPrice) && !isLoading"
              (click)="initiateSaleListing()">
              {{t('shared.proceed')}}
            </div>
            <div class="button-gradient disabled" *ngIf="confirmPrice!==listingPrice">
              {{t('shared.proceed')}}
            </div>
            <div class="button-gradient" *ngIf="isLoading">
              <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
            </div>
          </div>
        </div>
        <div class="sale-listing-success" *ngIf="isSuccess">
          <img src="{{pi.metadata.image}}" />
          <!-- <h3>{{t('assets.listedForSale',{name:pi.metadata.nameFormatted})}}</h3> -->
          <h3>{{t('assets.listedForSale',{name:t(pi.metadata.name+'.name'|replace:'powerup-':'' )})}}</h3>
          <div class="sale-modal-buttons">
            <div class="button-outline" (click)="closeListingProcedure()">
              {{t('shared.close')}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
